import { getById, getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetCustomerPartsApiParameter } from "@midland-industries/Services/CustomerPartService";
import { CustomState } from "@midland-industries/Store/CustomerPartNumberReducer";
import { createContext } from "react";

export function getCustomerPartState(state: CustomState, id: string | undefined) {
    return getById(state.customerParts, id);
}

export function getCustomerPartsDataView(state: CustomState, getCustomerPartsParameter: GetCustomerPartsApiParameter) {
    return getDataView(state.customerParts, getCustomerPartsParameter);
}

export const CustomerPartsDataViewContext = createContext<ReturnType<typeof getCustomerPartsDataView>>({
    value: undefined,
    isLoading: false,
});

export const CustomerPartsStateContext = createContext<ReturnType<typeof getCustomerPartState>>({
    value: undefined,
    isLoading: false,
    errorStatusCode: undefined,
    id: undefined,
});
